import { Stack, Typography } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";
import { useGetAnswersQuery } from "src/api/services/api";
import AnswerView from "../Answer";

interface Props {
  intakeSlug: string | null;
  patientId?: number;
}

const Answers = ({ intakeSlug, patientId }: Props) => {
  const { data: answers = [], isLoading } = useGetAnswersQuery(
    intakeSlug ? { visit_id: intakeSlug, patient_id: patientId } : skipToken,
  );

  if (isLoading === true) {
    return (
      <Typography pl={1} variant="body2">
        Loading answers...
      </Typography>
    );
  }

  if (answers.length === 0) {
    return (
      <Typography pl={1} variant="body2">
        No answers submitted
      </Typography>
    );
  }

  return (
    <Stack>
      {answers
        .filter((a) => a.response.answer[0] !== "Ignore")
        .map((answer, index) => (
          <AnswerView answer={answer} index={index} key={answer.question_id} />
        ))}
    </Stack>
  );
};

export default Answers;
